import type { UnitCode } from '~/graphql/graphql';

export type SettledUnit = { productId: string; unit: UnitCode };

/** Edit keys are not scoped per product, so only a unit change on the page's own product warrants a discard. */
export function isUnitChangeOnSameProduct(
  prev: SettledUnit | null,
  next: SettledUnit
): boolean {
  return prev?.productId === next.productId && prev.unit !== next.unit;
}
